import styled, { css } from 'styled-components';

export default css`
  .skeleton-view {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
  }
`;

export const StyledGenericContainer = styled.div`
  position: relative;
  padding-top: 120%;
  height: 0;
  margin-bottom: 20px;
  @media ${(props) => props.theme.mediaQuery.medium} {
    padding-top: 56%;
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    padding-top: 56%;
  }
`;
